/** المراجعة بالوكلاء لملفات التركز الاقتصادي (features/agentic). */
export default {
  title: "المراجعة بالوكلاء",
  subtitle: "التركز الاقتصادي",
  entry: "المراجعة بالوكلاء",
  entryHint: "فتح هذا الملف في المراجعة بالوكلاء على كامل الشاشة: فريق من الوكلاء يقرأ ويختبر ويصوغ بالتوازي، ويسأل الوكيل القائد الموظف عما يقرره وحده.",
  exit: "مغادرة المراجعة بالوكلاء",
  play: "استئناف",
  pause: "إيقاف مؤقت",
  speed: "السرعة",
  language: "تبديل اللغة",
  lightTheme: "النسخة الفاتحة",
  darkTheme: "النسخة الداكنة",
  close: "إغلاق",
  maximize: "تكبير",
  restore: "استعادة الحجم",
  chat: { title: "المحادثة", you: "أنت", ask: "سؤال إلى {{name}}…" },
  tabs: { conversation: "المحادثة", memory: "الذاكرة", sources: "المصادر" },
  memory: {
    kicker: "الذاكرة المؤسسية",
    intro: "ممارسة الإدارة – المنهج والتعليل، لا بيانات ملف آخر – وما سجلته هذه المراجعة. لا تُطبق أي ممارسة من تلقاء نفسها: تُعرض على الموظف سؤالاً، ولا تُسجل باسمه إلا بعد إجابته.",
    recalled: "مُستدعى",
    remembered: "محفوظ",
    recalledFrom: "استُدعي من ذاكرة الإدارة",
    rememberedFor: "حُفظ للملفات اللاحقة",
    learnedHere: "ما تعلمته هذه المراجعة",
    applied: "طُبق من الذاكرة",
    forget: "إزالة من الذاكرة",
    forgotten: "أُزيل: لن يُعرض في الملفات اللاحقة",
    kept: "محفوظ في ذاكرة الإدارة · مُدقق",
    recalledCount_zero: "لا شيء مُستدعى",
    recalledCount_one: "ذكرى واحدة مُستدعاة",
    recalledCount_two: "ذكريان مُستدعيان",
    recalledCount_few: "{{count}} ذكريات مُستدعاة",
    recalledCount_many: "{{count}} ذكرى مُستدعاة",
    recalledCount_other: "{{count}} ذكرى مُستدعاة",
    learnedCount_zero: "لا جديد",
    learnedCount_one: "ذكرى جديدة واحدة",
    learnedCount_two: "ذكريان جديدتان",
    learnedCount_few: "{{count}} ذكريات جديدة",
    learnedCount_many: "{{count}} ذكرى جديدة",
    learnedCount_other: "{{count}} ذكرى جديدة",
    emptyRecalled: "لم يُستدعَ شيء بعد: تُقرأ ممارسة الإدارة مع بدء المراجعة.",
    emptyLearned: "لم يُحفظ شيء بعد: تُحفظ هنا الممارسة التي تحددها والقرارات التي تتخذها للملفات اللاحقة.",
    kinds: { case: "ملف سابق", transaction: "صفقة مسجلة", commitment: "تعهد ساري", lesson: "درس من قرار مقيّم", practice: "ممارسة الإدارة", fact: "واقعة من هذا الملف", decision: "قرار متخذ في هذا الملف" },
  },
  sources: {
    kicker: "المصادر والتكاملات",
    intro: "كل نظام بلغه الوكلاء في هذه المراجعة – أنظمة الوزارة، والسجلات الحكومية، والتغذيات المرخصة، والويب المفتوح – مع آخر ما طُلب من كل منها.",
    reached: "ما بلغته هذه المراجعة",
    connected: "المتصلة بالمنصة",
    calls_zero: "لا استدعاءات",
    calls_one: "استدعاء واحد",
    calls_two: "استدعاءان",
    calls_few: "{{count}} استدعاءات",
    calls_many: "{{count}} استدعاءً",
    calls_other: "{{count}} استدعاء",
    failed_zero: "لا إخفاق",
    failed_one: "إخفاق واحد",
    failed_two: "إخفاقان",
    failed_few: "{{count}} إخفاقات",
    failed_many: "{{count}} إخفاقاً",
    failed_other: "{{count}} إخفاق",
    agents_zero: "لا وكلاء",
    agents_one: "وكيل واحد",
    agents_two: "وكيلان",
    agents_few: "{{count}} وكلاء",
    agents_many: "{{count}} وكيلاً",
    agents_other: "{{count}} وكيل",
    none: "لم يُبلغ أي مصدر بعد.",
    live: "مباشر",
    calls24h_zero: "لا استدعاء خلال 24 ساعة",
    calls24h_one: "استدعاء واحد خلال 24 ساعة",
    calls24h_two: "استدعاءان خلال 24 ساعة",
    calls24h_few: "{{count}} استدعاءات خلال 24 ساعة",
    calls24h_many: "{{count}} استدعاء خلال 24 ساعة",
    calls24h_other: "{{count}} استدعاء خلال 24 ساعة",
    strip: "المصادر",
    all: "كل المصادر",
    health: { Healthy: "سليم", Degraded: "متراجع", Down: "متوقف", Unknown: "لم يُفحص" },
    unavailable: "سجل التكاملات غير متاح لهذا الحساب.",
  },
  caseFile: "ملف الطلب",
  caseFileHint: "الانتقال إلى ملف الطلب التقليدي، السجل الرسمي، لمراجعة أي نتيجة وتأكيدها أو تجاوزها",
  igniting: "أجمع فريق الوكلاء…",
  log: "سجل الأحداث",
  logKinds: { think: "تفكير", tool: "أداة", result: "نتيجة", find: "استنتاج", ask: "سؤال", done: "اكتمل", lead: "القائد", spawn: "انضمام", error: "خطأ" },
  status: { queued: "في الانتظار", thinking: "يفكر", tool: "يستخدم الأدوات", writing: "يكتب", waiting: "بانتظارك", done: "اكتمل", flagged: "يستدعي الانتباه", failed: "توقف" },
  card: { spawning: "يبدأ العمل…" },
  squad: {
    documents: "الذكاء المستندي",
    documentsRole_zero: "لا قراء",
    documentsRole_one: "قارئ واحد لكل مستند مودع",
    documentsRole_two: "قارئان بالتوازي، واحد لكل مستند مودع",
    documentsRole_few: "{{count}} قراء بالتوازي، واحد لكل مستند مودع",
    documentsRole_many: "{{count}} قارئاً بالتوازي، واحد لكل مستند مودع",
    documentsRole_other: "{{count}} قارئ بالتوازي، واحد لكل مستند مودع",
  },
  lead: {
    kicker: "المنسق",
    name: "قائد الملف",
    active_zero: "لا وكلاء يعملون الآن",
    active_one: "وكيل واحد يعمل",
    active_two: "وكيلان يعملان",
    active_few: "{{count}} وكلاء يعملون",
    active_many: "{{count}} وكيلاً يعملون",
    active_other: "{{count}} وكيل يعملون",
    waiting_zero: "لا أسئلة لك",
    waiting_one: "سؤال واحد لك",
    waiting_two: "سؤالان لك",
    waiting_few: "{{count}} أسئلة لك",
    waiting_many: "{{count}} سؤالاً لك",
    waiting_other: "{{count}} سؤال لك",
    status: { idle: "خامل", reading: "يقرأ الملف", planning: "يخطط", dispatching: "يوزع المهام", listening: "ينسق", asking: "بانتظارك", concluding: "يستخلص النتائج", done: "اكتمل" },
    plan: "الخطة · {{phase}}",
    wave: "الموجة {{n}}",
    gate: "قرارك · {{phase}}",
    question: "يسأل {{agent}}",
    carrying: "أنفذ قرارك…",
    thinking: "يفكر…",
    ask: "سؤال إلى قائد الملف عن هذا الملف…",
    send: "إرسال",
    askHint: "يجيب مساعد الملفات في المنصة، بأدواته ومستندات الملف.",
    pending: "بانتظارك",
  },
  rail: { label: "الإجراء", intake: "الإخطار" },
  stats: { agents: "الوكلاء العاملون / على اللوحة", tools: "استدعاءات الأدوات", sources: "المصادر المقروءة", tokens: "النص المقروء والمكتوب بالرموز (تقدير)" },
  swarm: {
    agents_zero: "لا وكلاء",
    agents_one: "وكيل واحد",
    agents_two: "وكيلان",
    agents_few: "{{count}} وكلاء",
    agents_many: "{{count}} وكيلاً",
    agents_other: "{{count}} وكيل",
    live: "يعمل {{count}}",
    waiting: "بانتظارك {{count}}",
    done: "اكتمل {{count}}",
    flagged: "يستدعي الانتباه {{count}}",
    backToCurrent: "العودة إلى الموجة الحالية",
    assembling: "يجمع القائد هذه الموجة…",
  },
  focus: {
    trace: "المسار",
    findings: "النتائج",
    tools_zero: "لا استدعاءات للأدوات",
    tools_one: "استدعاء واحد للأدوات",
    tools_two: "استدعاءان للأدوات",
    tools_few: "{{count}} استدعاءات للأدوات",
    tools_many: "{{count}} استدعاءً للأدوات",
    tools_other: "{{count}} استدعاء للأدوات",
    sources_zero: "لا مصادر",
    sources_one: "مصدر واحد",
    sources_two: "مصدران",
    sources_few: "{{count}} مصادر",
    sources_many: "{{count}} مصدراً",
    sources_other: "{{count}} مصدر",
  },
  intake: {
    kicker: "التركز الاقتصادي · استلام الإخطار",
    headline1: "إخطار واحد.",
    headline2: "فريق كامل من الوكلاء.",
    lede: "إخطار الشركة كما قُدّم عبر البوابة – النموذج وكل المستندات. أرسل الوكلاء: يقرؤون ويتحققون ويقيسون السوق ويصوغون بالتوازي، وفق الإجراء مرحلة بمرحلة؛ ويسألك الوكيل القائد عما تقرره أنت وحدك.",
    new: "مقدّم خارج البوابة",
    newHint: "تسجيل طلب ورقي أو مرسل بالبريد الإلكتروني من الشركة",
    other: "ملف آخر…",
    files: "حزمة الطلب",
    filedPack: "قدمته الشركة",
    dropLate: "إضافة مستند أرسلته الشركة لاحقا",
    drop: "أفلت حزمة الطلب هنا",
    dropActive: "أفلت للإضافة إلى الملف",
    dropHint: "الاتفاقيات والقوائم المالية المدققة وتقارير السوق وهياكل الملكية والوكالات – PDF أو Word أو Excel أو صور",
    uploading: "يجري الرفع والاستخراج…",
    article10: "قائمة المادة 10",
    team: "فريق الوكلاء لهذا الملف",
    teamHint_zero: "لا وكلاء",
    teamHint_one: "وكيل واحد عبر الإجراء",
    teamHint_two: "وكيلان عبر الإجراء، يعملان بالتوازي في كل موجة",
    teamHint_few: "{{count}} وكلاء عبر الإجراء، يعملون بالتوازي في كل موجة",
    teamHint_many: "{{count}} وكيلاً عبر الإجراء، يعملون بالتوازي في كل موجة",
    teamHint_other: "{{count}} وكيل عبر الإجراء، يعملون بالتوازي في كل موجة",
    begin: "البدء من",
    live: "تشغيل وكلاء النماذج في المنصة أيضاً",
    liveHint: "يصوغ كاتب تقرير الدراسة وكاتب مذكرة القرار في وقت التشغيل الذكي؛ وتصل مسوداتهما كمقترحات لاعتمادك.",
    liveOffline: "وقت التشغيل الذكي غير متصل: يعمل الوكلاء بقواعد المنصة وبياناتها ومستنداتها.",
    analyse: "التحليل بالوكلاء",
    needs: "يلزم عنوان وطرفان وسوق معنية للبدء.",
    reading: "قيد القراءة",
    remove: "إزالة",
    notOnForm: "غير مدرج في النموذج",
    form: "الإخطار",
    asFiled: "كما قُدّم",
    transaction: "الصفقة",
    title: "العنوان",
    type: "النوع",
    consideration: "المقابل",
    considerationAed: "المقابل (درهم)",
    signing: "تاريخ التوقيع",
    closing: "الإتمام المتوقع",
    description: "الوصف",
    parties: "الأطراف",
    control: "السيطرة",
    stake: "الحصة المستحوذ عليها (%)",
    preStake: "الحصة قبل الصفقة (%)",
    controlType: "السيطرة",
    markets: "المبيعات والأسواق المعنية",
    turnover: "المبيعات المجمعة في الدولة",
    turnoverAed: "المبيعات المجمعة في الدولة (درهم)",
    fiscalYear: "السنة المالية",
    newForm: "إخطار جديد",
    acquirer: "الجهة المستحوذة",
    target: "الشركة المستهدفة",
    licence: "الرخصة",
    emirate: "الإمارة",
    product: "سوق المنتج",
    geography: "السوق الجغرافية",
    marketSizeAed: "حجم السوق (درهم)",
    acquirerShare: "حصة المستحوذ (%)",
    targetShare: "حصة المستهدفة (%)",
    competitors: "المنافسون",
    competitor: "منافس",
    addCompetitor: "إضافة منافس",
  },
  /** الكلمات المعدودة في نصوص الوكلاء: صيغ العدد كما في بقية الشاشات (صفر، واحد، اثنان، 3–10، 11–99، غير ذلك). */
  count: {
    days_zero: "لا أيام", days_one: "يوم واحد", days_two: "يومان", days_few: "{{count}} أيام", days_many: "{{count}} يوماً", days_other: "{{count}} يوم",
    workingDays_zero: "لا أيام عمل", workingDays_one: "يوم عمل واحد", workingDays_two: "يوما عمل", workingDays_few: "{{count}} أيام عمل", workingDays_many: "{{count}} يوم عمل", workingDays_other: "{{count}} يوم عمل",
    documents_zero: "لا مستندات", documents_one: "مستند واحد", documents_two: "مستندان", documents_few: "{{count}} مستندات", documents_many: "{{count}} مستنداً", documents_other: "{{count}} مستند",
    parties_zero: "لا أطراف", parties_one: "طرف واحد", parties_two: "طرفان", parties_few: "{{count}} أطراف", parties_many: "{{count}} طرفاً", parties_other: "{{count}} طرف",
    markets_zero: "لا أسواق معنية", markets_one: "سوق معنية واحدة", markets_two: "سوقان معنيتان", markets_few: "{{count}} أسواق معنية", markets_many: "{{count}} سوقاً معنية", markets_other: "{{count}} سوق معنية",
    agents_zero: "لا وكلاء", agents_one: "وكيل واحد", agents_two: "وكيلان", agents_few: "{{count}} وكلاء", agents_many: "{{count}} وكيلاً", agents_other: "{{count}} وكيل",
    toolCalls_zero: "لا استدعاءات للأدوات", toolCalls_one: "استدعاء واحد للأدوات", toolCalls_two: "استدعاءان للأدوات", toolCalls_few: "{{count}} استدعاءات للأدوات", toolCalls_many: "{{count}} استدعاءً للأدوات", toolCalls_other: "{{count}} استدعاء للأدوات",
    sources_zero: "لا مصادر", sources_one: "مصدر واحد", sources_two: "مصدران", sources_few: "{{count}} مصادر", sources_many: "{{count}} مصدراً", sources_other: "{{count}} مصدر",
    decisions_zero: "لا قرارات", decisions_one: "قرار واحد", decisions_two: "قراران", decisions_few: "{{count}} قرارات", decisions_many: "{{count}} قراراً", decisions_other: "{{count}} قرار",
    practices_zero: "لا ممارسات", practices_one: "ممارسة واحدة", practices_two: "ممارستان", practices_few: "{{count}} ممارسات", practices_many: "{{count}} ممارسة", practices_other: "{{count}} ممارسة",
    memories_zero: "لا ذكريات", memories_one: "ذكرى واحدة", memories_two: "ذكريان", memories_few: "{{count}} ذكريات", memories_many: "{{count}} ذكرى", memories_other: "{{count}} ذكرى",
    gaps_zero: "لا بنود ناقصة", gaps_one: "بند ناقص واحد", gaps_two: "بندان ناقصان", gaps_few: "{{count}} بنود ناقصة", gaps_many: "{{count}} بنداً ناقصاً", gaps_other: "{{count}} بند ناقص",
    letters_zero: "لا خطابات", letters_one: "خطاب واحد", letters_two: "خطابان", letters_few: "{{count}} خطابات", letters_many: "{{count}} خطاباً", letters_other: "{{count}} خطاب",
    redactions_zero: "لا مواضع محجوبة", redactions_one: "موضع محجوب واحد", redactions_two: "موضعان محجوبان", redactions_few: "{{count}} مواضع محجوبة", redactions_many: "{{count}} موضعاً محجوباً", redactions_other: "{{count}} موضع محجوب",
    sections_zero: "لا أقسام", sections_one: "قسم واحد", sections_two: "قسمان", sections_few: "{{count}} أقسام", sections_many: "{{count}} قسماً", sections_other: "{{count}} قسم",
    figures_zero: "لا أرقام", figures_one: "رقم واحد", figures_two: "رقمان", figures_few: "{{count}} أرقام", figures_many: "{{count}} رقماً", figures_other: "{{count}} رقم",
    firms_zero: "لا منشآت", firms_one: "منشأة واحدة", firms_two: "منشأتان", firms_few: "{{count}} منشآت", firms_many: "{{count}} منشأة", firms_other: "{{count}} منشأة",
    years_zero: "لا سنوات", years_one: "سنة واحدة", years_two: "سنتان", years_few: "{{count}} سنوات", years_many: "{{count}} سنة", years_other: "{{count}} سنة",
    passages_zero: "لا مقاطع", passages_one: "مقطع واحد", passages_two: "مقطعان", passages_few: "{{count}} مقاطع", passages_many: "{{count}} مقطعاً", passages_other: "{{count}} مقطع",
    instruments_zero: "لا صكوك", instruments_one: "صك واحد", instruments_two: "صكان", instruments_few: "{{count}} صكوك", instruments_many: "{{count}} صكاً", instruments_other: "{{count}} صك",
    items_zero: "لا مواد", items_one: "مادة واحدة", items_two: "مادتان", items_few: "{{count}} مواد", items_many: "{{count}} مادة", items_other: "{{count}} مادة",
    pages_zero: "لا صفحات", pages_one: "صفحة واحدة", pages_two: "صفحتان", pages_few: "{{count}} صفحات", pages_many: "{{count}} صفحة", pages_other: "{{count}} صفحة",
    entities_zero: "لا كيانات", entities_one: "كيان واحد", entities_two: "كيانان", entities_few: "{{count}} كيانات", entities_many: "{{count}} كياناً", entities_other: "{{count}} كيان",
    links_zero: "لا روابط", links_one: "رابط واحد", links_two: "رابطان", links_few: "{{count}} روابط", links_many: "{{count}} رابطاً", links_other: "{{count}} رابط",
    nodes_zero: "لا عقد", nodes_one: "عقدة واحدة", nodes_two: "عقدتان", nodes_few: "{{count}} عقد", nodes_many: "{{count}} عقدة", nodes_other: "{{count}} عقدة",
    queries_zero: "لا استعلامات", queries_one: "استعلام واحد", queries_two: "استعلامان", queries_few: "{{count}} استعلامات", queries_many: "{{count}} استعلاماً", queries_other: "{{count}} استعلام",
    discrepancies_zero: "لا فروق", discrepancies_one: "فرق واحد", discrepancies_two: "فرقان", discrepancies_few: "{{count}} فروق", discrepancies_many: "{{count}} فرقاً", discrepancies_other: "{{count}} فرق",
    views_zero: "لا مرئيات", views_one: "رأي واحد", views_two: "رأيان", views_few: "{{count}} آراء", views_many: "{{count}} رأياً", views_other: "{{count}} رأي",
    objections_zero: "لا اعتراضات", objections_one: "اعتراض واحد", objections_two: "اعتراضان", objections_few: "{{count}} اعتراضات", objections_many: "{{count}} اعتراضاً", objections_other: "{{count}} اعتراض",
    authorities_zero: "لا جهات", authorities_one: "جهة واحدة", authorities_two: "جهتان", authorities_few: "{{count}} جهات", authorities_many: "{{count}} جهة", authorities_other: "{{count}} جهة",
    regulators_zero: "لا جهات تنظيمية", regulators_one: "جهة تنظيمية واحدة", regulators_two: "جهتان تنظيميتان", regulators_few: "{{count}} جهات تنظيمية", regulators_many: "{{count}} جهة تنظيمية", regulators_other: "{{count}} جهة تنظيمية",
    facts_zero: "لا وقائع", facts_one: "واقعة واحدة", facts_two: "واقعتان", facts_few: "{{count}} وقائع", facts_many: "{{count}} واقعة", facts_other: "{{count}} واقعة",
    characters_zero: "لا أحرف", characters_one: "حرف واحد", characters_two: "حرفان", characters_few: "{{count}} أحرف", characters_many: "{{count}} حرفاً", characters_other: "{{count}} حرف",
    checklistItems_zero: "لا بنود", checklistItems_one: "بند واحد", checklistItems_two: "بندان", checklistItems_few: "{{count}} بنود", checklistItems_many: "{{count}} بنداً", checklistItems_other: "{{count}} بند",
    acquirers_zero: "لا مستحوذين", acquirers_one: "مستحوذ واحد", acquirers_two: "مستحوذان", acquirers_few: "{{count}} مستحوذين", acquirers_many: "{{count}} مستحوذاً", acquirers_other: "{{count}} مستحوذ",
    licences_zero: "لا رخص", licences_one: "رخصة واحدة", licences_two: "رخصتان", licences_few: "{{count}} رخص", licences_many: "{{count}} رخصة", licences_other: "{{count}} رخصة",
    records_zero: "لا سجلات", records_one: "سجل واحد", records_two: "سجلان", records_few: "{{count}} سجلات", records_many: "{{count}} سجلاً", records_other: "{{count}} سجل",
    elements_zero: "لا عناصر", elements_one: "عنصر واحد", elements_two: "عنصران", elements_few: "{{count}} عناصر", elements_many: "{{count}} عنصراً", elements_other: "{{count}} عنصر",
    checks_zero: "لا فحوص", checks_one: "فحص واحد", checks_two: "فحصان", checks_few: "{{count}} فحوص", checks_many: "{{count}} فحصاً", checks_other: "{{count}} فحص",
    points_zero: "لا نقاط", points_one: "نقطة واحدة", points_two: "نقطتان", points_few: "{{count}} نقاط", points_many: "{{count}} نقطة", points_other: "{{count}} نقطة",
  },
  types: { Acquisition: "استحواذ", Merger: "اندماج", JointVenture: "مشروع مشترك", AssetTransfer: "نقل أصول", ControlChange: "تغيير السيطرة" },
  roles: { AcquiringParty: "الجهة المستحوذة", TargetParty: "الشركة المستهدفة", Representative: "الممثل", Seller: "البائع", Other: "طرف" },
  control: { Unknown: "غير محدد", None: "لا سيطرة", Sole: "سيطرة منفردة", Joint: "سيطرة مشتركة" },
};
